/*
 * @Author: Merlin
 * @Date: 2024-05-29 16:47:38
 * @LastEditors: Merlin
 * @LastEditTime: 2025-01-22 13:21:48
 * @Description: 
 */
// import diceImage from '@/assets/imgs/casino/game-icon-new/dice.png';
// import spaceDiceImage from '@/assets/imgs/casino/game-icon-new/spacedice.png';
// import limboImage from '@/assets/imgs/casino/game-icon-new/limbo.png';
// import coinflipImage from '@/assets/imgs/casino/game-icon-new/coinflip.png';
// import plinkoImage from '@/assets/imgs/casino/game-icon-new/plinko.png';
// import crashImage from '@/assets/imgs/casino/game-icon-new/crash.png';
// import minesImage from '@/assets/imgs/casino/game-icon-new/mines.png';
// import ringImage from '@/assets/imgs/casino/game-icon-new/ring.png';
// import cryptosImage from '@/assets/imgs/casino/game-icon-new/cryptos.png';
// import tripleImage from '@/assets/imgs/casino/game-icon-new/triple.png';
// import wildImage from '@/assets/imgs/casino/game-icon-new/wild.png';
// import towerImage from '@/assets/imgs/casino/game-icon-new/tower.png';
// import hiloImage from '@/assets/imgs/casino/game-icon-new/hilo.png';
// import kenoImage from '@/assets/imgs/casino/game-icon-new/keno.png';
// import rouletteImage from '@/assets/imgs/casino/game-icon-new/roulette.png';
// import pharaohImage from '@/assets/imgs/casino/game-icon-new/pharaoh.png';
// import stairsImage from '@/assets/imgs/casino/game-icon-new/stairs.png';
// import circleImage from '@/assets/imgs/casino/game-icon-new/circle.png';
// import blackjackImage from '@/assets/imgs/casino/game-icon-new/black-jack.png';
// import corgiwavesImage from '@/assets/imgs/casino/game-icon-new/corgiwaves.webp';

// 👇 游戏列表（用于桌面版导航）
export const aBetCorgiGames = [
    // 👇 通过这里的 label 取得国际化信息
    // img 记录游戏图标 icon
    // imgName 记录着游戏封面图名称
    { path: '/casino/diceGame', label: 'Dice', imgName: 'dice' },
    {
        path: '/casino/spacediceGame',
        label: 'SpaceDice',
        imgName: 'spacedice',
    },
    { path: '/casino/limboGame', label: 'Limbo', imgName: 'limbo' },
    { 
        path: '/casino/plinkoGame', 
        label: 'Plinko', 
        imgName: 'plinko',
    },
    // ------------------------
    { path: '/casino/rouletteGame', label: 'Roulette', imgName: 'roulette' },
    { path: '/casino/coinflipGame', label: 'CoinFlip', imgName: 'coinflip' },
    { path: '/casino/kenoGame', label: 'Keno', imgName: 'keno' },
    { path: '/casino/crashGame', label: 'Crash', imgName: 'crash' },
    // ------------------------
    { path: '/casino/minesGame', label: 'Mines', imgName: 'mines' },
    { path: '/casino/ringGame', label: 'Ring', imgName: 'ring' },
    { path: '/casino/cryptosGame', label: 'Cryptos', imgName: 'cryptos' },
    { path: '/casino/towerGame', label: 'Tower', imgName: 'tower' },
    // ----------------------
    { path: '/casino/corgipharaohGame', label: 'Pharaoh', imgName: 'corgipharaoh' },
    { path: '/casino/hiloGame', label: 'HiLo', imgName: 'hilo' },
    { path: '/casino/StairsGame', label: 'Stairs', imgName: 'stairs' },
    { path: '/casino/corgiwildGame', label: 'CorgiWild', imgName: 'corgiwild' },
    // -----------------------
    { path: '/casino/circleGame', label: 'Circle', imgName: 'circle' },
    { path: '/casino/tripleGame', label: 'Triple', imgName: 'triple' },
    { path: '/casino/blackjackGame', label: 'Blackjack', imgName: 'blackjack' },
    { path: '/casino/corgiwavesGame', label: 'CorgiWaves', imgName: 'blackjack' },
];

/*
    ↑ 已经删除了 img: ***，这是游戏在导航栏中的图标，在 mini 版中没有使用到，因为 mini 版没有导航 
    ↓ 下方是原版，没有删除 img: ***,
    观察一段时间，如果运行良好，删除下方备份内容，删除顶部 import，删除相关的 *.png 图标文件 
*/

// export const aBetCorgiGames = [
//     // 👇 通过这里的 label 取得国际化信息
//     // img 记录游戏图标 icon
//     // imgName 记录着游戏封面图名称
//     { path: '/casino/diceGame', label: 'Dice', img: diceImage, imgName: 'dice' },
//     {
//         path: '/casino/spacediceGame',
//         label: 'SpaceDice',
//         img: spaceDiceImage,
//         imgName: 'spacedice',
//     },
//     { path: '/casino/limboGame', label: 'Limbo', img: limboImage, imgName: 'limbo' },
//     { 
//         path: '/casino/plinkoGame', 
//         label: 'Plinko', 
//         img: plinkoImage, 
//         imgName: 'plinko',
//     },
//     // ------------------------
//     { path: '/casino/rouletteGame', label: 'Roulette', img: rouletteImage, imgName: 'roulette' },
//     { path: '/casino/coinflipGame', label: 'CoinFlip', img: coinflipImage, imgName: 'coinflip' },
//     { path: '/casino/kenoGame', label: 'Keno', img: kenoImage, imgName: 'keno' },
//     { path: '/casino/crashGame', label: 'Crash', img: crashImage, imgName: 'crash' },
//     // ------------------------
//     { path: '/casino/minesGame', label: 'Mines', img: minesImage, imgName: 'mines' },
//     { path: '/casino/ringGame', label: 'Ring', img: ringImage, imgName: 'ring' },
//     { path: '/casino/cryptosGame', label: 'Cryptos', img: cryptosImage, imgName: 'cryptos' },
//     { path: '/casino/towerGame', label: 'Tower', img: towerImage, imgName: 'tower' },
//     // ----------------------
//     { path: '/casino/corgipharaohGame', label: 'Pharaoh', img: pharaohImage, imgName: 'corgipharaoh' },
//     { path: '/casino/hiloGame', label: 'HiLo', img: hiloImage, imgName: 'hilo' },
//     { path: '/casino/StairsGame', label: 'Stairs', img: stairsImage, imgName: 'stairs' },
//     { path: '/casino/corgiwildGame', label: 'CorgiWild', img: wildImage, imgName: 'corgiwild' },
//     // -----------------------
//     { path: '/casino/circleGame', label: 'Circle', img: circleImage, imgName: 'circle' },
//     { path: '/casino/tripleGame', label: 'Triple', img: tripleImage, imgName: 'triple' },
//     { path: '/casino/blackjackGame', label: 'Blackjack', img: blackjackImage, imgName: 'blackjack' },
//     { path: '/casino/corgiwavesGame', label: 'CorgiWaves', img: corgiwavesImage, imgName: 'blackjack' },
// ];


